import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import { EMPLOYER_BLOCKS_FETCH_BEGIN } from './action-types'
import { fetchEmployerBlocks } from './api'

export function* saga() {
  yield takeLatestApiCall(EMPLOYER_BLOCKS_FETCH_BEGIN, fetchEmployerBlocks)
}
